<div class="offer-slider slider" #banners>
  <ng-container *ngFor="let specialBanner of specialBanners; let i = index">
    <div class="offer-slider__item" *ngFor="let specialBanner of specialBanners" (click)="redirect(specialBanner.url)">
      <div class="offer-main offer-change-ringtone offer-holidays" [ngStyle]="{'background': specialBanner.hexColor}">
        <div class="container container_type_offer-main">
          <div class="offer-main__content">
            <div class="offer-main__title">{{ specialBanner.title }}</div>
            <div class="offer-main__text">{{ getText(specialBanner) }}</div>
          </div>
          <div class="offer-main__img offer-change-ringtone__img">
            <img [src]="specialBanner.bannerUrl"/>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="offer-slider__item">
    <div class="offer-pink offer-pink-dragon">
      <div class="offer-pink__content">
        <div class="offer-pink__title">{{ 'privet-plus-banner.title' | translate }}</div>
        <div class="offer-pink__text">{{ 'privet-plus-banner.text' | translate }}</div>
      </div>
      <div class="offer-pink-dragon__img">
        <img src="img/offers/offer_05.png"/>
      </div>
    </div>
  </div>

  <div class="offer-slider__item" (click)="activateService()">
    <div class="offer-main offer-change-ringtone">
      <div class="container container_type_offer-main">
        <div class="offer-main__content">
          <div class="offer-main__title">{{ 'privet-plus-banner.change-goodok' | translate }}</div>
          <div class="offer-main__text">{{ 'privet-plus-banner.change-goodok-description' | translate }}</div>
        </div>
        <div class="offer-main__img offer-change-ringtone__img">
          <img src="img/offers/offer_04.png"/>
        </div>
      </div>
    </div>
  </div>

<!--  <div class="offer-slider__item" (click)="redirectToUgc()">-->
<!--    <div class="offer-main offer-change-ringtone">-->
<!--      <div class="container container_type_offer-main">-->
<!--        <div class="offer-main__content">-->
<!--          <div class="offer-main__title">Загрузи свой гудок</div>-->
<!--          <div class="offer-main__text">Установите свою мелодию на гудок</div>-->
<!--        </div>-->
<!--        <div class="offer-main__img offer-change-ringtone__img">-->
<!--          <img src="img/offers/offer_06.png"/>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</div>
